import NOFLAG1 from "./images/NOFLAG.png";
import CP1 from "./images/CP1.png";
import CP2 from "./images/CP2.png";
import CP3 from "./images/CP3.png";
import OLY1 from "./images/OLY1.png";
import OLY2 from "./images/OLY2.png";
import AFG from "./images/AFG.svg";
import ALB from "./images/ALB.svg";
import ALG from "./images/ALG.svg";
import AIN from "./images/AIN.svg";
import AND from "./images/AND.svg";
import ANG from "./images/ANG.svg";
import ANT from "./images/ANT.svg";
import ARG from "./images/ARG.svg";
import ARM from "./images/ARM.svg";
import ARU from "./images/ARU.svg";
import ASA from "./images/ASA.svg";
import AUS from "./images/AUS.svg";
import AUT from "./images/AUT.svg";
import AZE from "./images/AZE.svg";
import BAH from "./images/BAH.svg";
import BAN from "./images/BAN.svg";
import BAR from "./images/BAR.svg";
import BDI from "./images/BDI.svg";
import BEL from "./images/BEL.svg";
import BEN from "./images/BEN.svg";
import BER from "./images/BER.svg";
import BHU from "./images/BHU.svg";
import BIH from "./images/BIH.svg";
import BIZ from "./images/BIZ.svg";
import BLR from "./images/BLR.svg";
import BOL from "./images/BOL.svg";
import BOT from "./images/BOT.svg";
import BRA from "./images/BRA.svg";
import BRN from "./images/BRN.svg";
import BRU from "./images/BRU.svg";
import BUL from "./images/BUL.svg";
import BUR from "./images/BUR.svg";
import CAF from "./images/CAF.svg";
import CAM from "./images/CAM.svg";
import CAN from "./images/CAN.svg";
import CAY from "./images/CAY.svg";
import CGO from "./images/CGO.svg";
import CHA from "./images/CHA.svg";
import CHI from "./images/CHI.svg";
import CHN from "./images/CHN.svg";
import CIV from "./images/CIV.svg";
import CMR from "./images/CMR.svg";
import COD from "./images/COD.svg";
import COK from "./images/COK.svg";
import COL from "./images/COL.svg";
import COM from "./images/COM.svg";
import CPV from "./images/CPV.svg";
import CRC from "./images/CRC.svg";
import CRO from "./images/CRO.svg";
import CUB from "./images/CUB.svg";
import CYP from "./images/CYP.svg";
import CZE from "./images/CZE.svg";
import DEN from "./images/DEN.svg";
import DJI from "./images/DJI.svg";
import DMA from "./images/DMA.svg";
import DOM from "./images/DOM.svg";
import ECU from "./images/ECU.svg";
import EGY from "./images/EGY.svg";
import ERI from "./images/ERI.svg";
import ESA from "./images/ESA.svg";
import ESP from "./images/ESP.svg";
import EST from "./images/EST.svg";
import ETH from "./images/ETH.svg";
import FIJ from "./images/FIJ.svg";
import FIN from "./images/FIN.svg";
import FRA from "./images/FRA.svg";
import FSM from "./images/FSM.svg";
import GAB from "./images/GAB.svg";
import GAM from "./images/GAM.svg";
import GBR from "./images/GBR.svg";
import GBS from "./images/GBS.svg";
import GEO from "./images/GEO.svg";
import GEQ from "./images/GEQ.svg";
import GER from "./images/GER.svg";
import GHA from "./images/GHA.svg";
import GRE from "./images/GRE.svg";
import GRN from "./images/GRN.svg";
import GUA from "./images/GUA.svg";
import GUI from "./images/GUI.svg";
import GUM from "./images/GUM.svg";
import GUY from "./images/GUY.svg";
import HAI from "./images/HAI.svg";
import HKG from "./images/HKG.svg";
import HON from "./images/HON.svg";
import HUN from "./images/HUN.svg";
import INA from "./images/INA.svg";
import IND from "./images/IND.svg";
import IOT from "./images/IOT.svg";
import IRI from "./images/IRI.svg";
import IRL from "./images/IRL.svg";
import IRQ from "./images/IRQ.svg";
import ISL from "./images/ISL.svg";
import ISR from "./images/ISR.svg";
import ISV from "./images/ISV.svg";
import ITA from "./images/ITA.svg";
import IVB from "./images/IVB.svg";
import JAM from "./images/JAM.svg";
import JOR from "./images/JOR.svg";
import JPN from "./images/JPN.svg";
import KAZ from "./images/KAZ.svg";
import KEN from "./images/KEN.svg";
import KGZ from "./images/KGZ.svg";
import KIR from "./images/KIR.svg";
import KOR from "./images/KOR.svg";
import KOS from "./images/KOS.svg";
import KSA from "./images/KSA.svg";
import KUW from "./images/KUW.svg";
import LAO from "./images/LAO.svg";
import LAT from "./images/LAT.svg";
import LBA from "./images/LBA.svg";
import LBN from "./images/LBN.svg";
import LBR from "./images/LBR.svg";
import LCA from "./images/LCA.svg";
import LES from "./images/LES.svg";
import LIE from "./images/LIE.svg";
import LTU from "./images/LTU.svg";
import LUX from "./images/LUX.svg";
import MAD from "./images/MAD.svg";
import MAR from "./images/MAR.svg";
import MAS from "./images/MAS.svg";
import MAW from "./images/MAW.svg";
import MDA from "./images/MDA.svg";
import MDV from "./images/MDV.svg";
import MEX from "./images/MEX.svg";
import MGL from "./images/MGL.svg";
import MHL from "./images/MHL.svg";
import MKD from "./images/MKD.svg";
import MLI from "./images/MLI.svg";
import MLT from "./images/MLT.svg";
import MNE from "./images/MNE.svg";
import MON from "./images/MON.svg";
import MOZ from "./images/MOZ.svg";
import MRI from "./images/MRI.svg";
import MTN from "./images/MTN.svg";
import MYA from "./images/MYA.svg";
import NAM from "./images/NAM.svg";
import NCA from "./images/NCA.svg";
import NED from "./images/NED.svg";
import NEP from "./images/NEP.svg";
import NGR from "./images/NGR.svg";
import NIG from "./images/NIG.svg";
import NOR from "./images/NOR.svg";
import NRU from "./images/NRU.svg";
import NZL from "./images/NZL.svg";
import OAR from "./images/OAR.svg";
import OMA from "./images/OMA.svg";
import PAK from "./images/PAK.svg";
import PAN from "./images/PAN.svg";
import PAR from "./images/PAR.svg";
import PER from "./images/PER.svg";
import PHI from "./images/PHI.svg";
import PLE from "./images/PLE.svg";
import PLW from "./images/PLW.svg";
import PNG from "./images/PNG.svg";
import POL from "./images/POL.svg";
import POR from "./images/POR.svg";
import PRK from "./images/PRK.svg";
import PUR from "./images/PUR.svg";
import QAT from "./images/QAT.svg";
import ROC from "./images/ROC.svg";
import ROT from "./images/ROT.svg";
import ROU from "./images/ROU.svg";
import RSA from "./images/RSA.svg";
import RUS from "./images/RUS.svg";
import RWA from "./images/RWA.svg";
import SAM from "./images/SAM.svg";
import SEN from "./images/SEN.svg";
import SEY from "./images/SEY.svg";
import SGP from "./images/SGP.svg";
import SKN from "./images/SKN.svg";
import SLE from "./images/SLE.svg";
import SLO from "./images/SLO.svg";
import SMR from "./images/SMR.svg";
import SOL from "./images/SOL.svg";
import SOM from "./images/SOM.svg";
import SRB from "./images/SRB.svg";
import SRI from "./images/SRI.svg";
import SSD from "./images/SSD.svg";
import STP from "./images/STP.svg";
import SUD from "./images/SUD.svg";
import SUI from "./images/SUI.svg";
import SUR from "./images/SUR.svg";
import SVK from "./images/SVK.svg";
import SWE from "./images/SWE.svg";
import SWZ from "./images/SWZ.svg";
import SYR from "./images/SYR.svg";
import TAN from "./images/TAN.svg";
import TGA from "./images/TGA.svg";
import THA from "./images/THA.svg";
import TJK from "./images/TJK.svg";
import TKM from "./images/TKM.svg";
import TLS from "./images/TLS.svg";
import TOG from "./images/TOG.svg";
import TPE from "./images/TPE.svg";
import TTO from "./images/TTO.svg";
import TUN from "./images/TUN.svg";
import TUR from "./images/TUR.svg";
import TUV from "./images/TUV.svg";
import TWN from "./images/TWN.svg";
import UAE from "./images/UAE.svg";
import UGA from "./images/UGA.svg";
import UKR from "./images/UKR.svg";
import URU from "./images/URU.svg";
import USA from "./images/USA.svg";
import UZB from "./images/UZB.svg";
import VAN from "./images/VAN.svg";
import VEN from "./images/VEN.svg";
import VIE from "./images/VIE.svg";
import VIN from "./images/VIN.svg";
import YEM from "./images/YEM.svg";
import ZAM from "./images/ZAM.svg";
import ZIM from "./images/ZIM.svg";
import EOR from "./images/EOR.svg";
import gold from "./images/fluent-emoji-flat_1st-place-medal.svg"
import silver from "./images/fluent-emoji-flat_2nd-place-medal.svg"
import bronze from "./images/fluent-emoji-flat_3rd-place-medal.svg"
const images = new Map();
images.set("AFG", AFG);
images.set("ALB", ALB);
images.set("ALG", ALG);
images.set("AIN", AIN);
images.set("AND", AND);
images.set("ANG", ANG);
images.set("ANT", ANT);
images.set("ARG", ARG);
images.set("ARM", ARM);
images.set("ARU", ARU);
images.set("ASA", ASA);
images.set("AUS", AUS);
images.set("AUT", AUT);
images.set("AZE", AZE);
images.set("BAH", BAH);
images.set("BAN", BAN);
images.set("BAR", BAR);
images.set("BDI", BDI);
images.set("BEL", BEL);
images.set("BEN", BEN);
images.set("BER", BER);
images.set("BHU", BHU);
images.set("BIH", BIH);
images.set("BIZ", BIZ);
images.set("BLR", BLR);
images.set("BOL", BOL);
images.set("BOT", BOT);
images.set("BRA", BRA);
images.set("BRN", BRN);
images.set("BRU", BRU);
images.set("BUL", BUL);
images.set("BUR", BUR);
images.set("CAF", CAF);
images.set("CAM", CAM);
images.set("CAN", CAN);
images.set("CAY", CAY);
images.set("CGO", CGO);
images.set("CHA", CHA);
images.set("CHI", CHI);
images.set("CHN", CHN);
images.set("CIV", CIV);
images.set("CMR", CMR);
images.set("COD", COD);
images.set("COK", COK);
images.set("COL", COL);
images.set("COM", COM);
images.set("CPV", CPV);
images.set("CRC", CRC);
images.set("CRO", CRO);
images.set("CUB", CUB);
images.set("CYP", CYP);
images.set("CZE", CZE);
images.set("DEN", DEN);
images.set("DJI", DJI);
images.set("DMA", DMA);
images.set("DOM", DOM);
images.set("ECU", ECU);
images.set("EGY", EGY);
images.set("ERI", ERI);
images.set("ESA", ESA);
images.set("ESP", ESP);
images.set("EST", EST);
images.set("ETH", ETH);
images.set("FIJ", FIJ);
images.set("FIN", FIN);
images.set("FRA", FRA);
images.set("FSM", FSM);
images.set("GAB", GAB);
images.set("GAM", GAM);
images.set("GBR", GBR);
images.set("GBS", GBS);
images.set("GEO", GEO);
images.set("GEQ", GEQ);
images.set("GER", GER);
images.set("GHA", GHA);
images.set("GRE", GRE);
images.set("GRN", GRN);
images.set("GUA", GUA);
images.set("GUI", GUI);
images.set("GUM", GUM);
images.set("GUY", GUY);
images.set("HAI", HAI);
images.set("HKG", HKG);
images.set("HON", HON);
images.set("HUN", HUN);
images.set("INA", INA);
images.set("IND", IND);
images.set("IOT", IOT);
images.set("IRI", IRI);
images.set("IRL", IRL);
images.set("IRQ", IRQ);
images.set("ISL", ISL);
images.set("ISR", ISR);
images.set("ISV", ISV);
images.set("ITA", ITA);
images.set("IVB", IVB);
images.set("JAM", JAM);
images.set("JOR", JOR);
images.set("JPN", JPN);
images.set("KAZ", KAZ);
images.set("KEN", KEN);
images.set("KGZ", KGZ);
images.set("KIR", KIR);
images.set("KOR", KOR);
images.set("KOS", KOS);
images.set("KSA", KSA);
images.set("KUW", KUW);
images.set("LAO", LAO);
images.set("LAT", LAT);
images.set("LBA", LBA);
images.set("LBN", LBN);
images.set("LBR", LBR);
images.set("LCA", LCA);
images.set("LES", LES);
images.set("LIE", LIE);
images.set("LTU", LTU);
images.set("LUX", LUX);
images.set("MAD", MAD);
images.set("MAR", MAR);
images.set("MAS", MAS);
images.set("MAW", MAW);
images.set("MDA", MDA);
images.set("MDV", MDV);
images.set("MEX", MEX);
images.set("MGL", MGL);
images.set("MHL", MHL);
images.set("MKD", MKD);
images.set("MLI", MLI);
images.set("MLT", MLT);
images.set("MNE", MNE);
images.set("MON", MON);
images.set("MOZ", MOZ);
images.set("MRI", MRI);
images.set("MTN", MTN);
images.set("MYA", MYA);
images.set("NAM", NAM);
images.set("NCA", NCA);
images.set("NED", NED);
images.set("NEP", NEP);
images.set("NGR", NGR);
images.set("NIG", NIG);
images.set("NOR", NOR);
images.set("NRU", NRU);
images.set("NZL", NZL);
images.set("OAR", OAR);
images.set("OMA", OMA);
images.set("PAK", PAK);
images.set("PAN", PAN);
images.set("PAR", PAR);
images.set("PER", PER);
images.set("PHI", PHI);
images.set("PLE", PLE);
images.set("PLW", PLW);
images.set("PNG", PNG);
images.set("POL", POL);
images.set("POR", POR);
images.set("PRK", PRK);
images.set("PUR", PUR);
images.set("QAT", QAT);
images.set("ROC", ROC);
images.set("ROT", ROT);
images.set("ROU", ROU);
images.set("RSA", RSA);
images.set("RUS", RUS);
images.set("RWA", RWA);
images.set("SAM", SAM);
images.set("SEN", SEN);
images.set("SEY", SEY);
images.set("SGP", SGP);
images.set("SKN", SKN);
images.set("SLE", SLE);
images.set("SLO", SLO);
images.set("SMR", SMR);
images.set("SOL", SOL);
images.set("SOM", SOM);
images.set("SRB", SRB);
images.set("SRI", SRI);
images.set("SSD", SSD);
images.set("STP", STP);
images.set("SUD", SUD);
images.set("SUI", SUI);
images.set("SUR", SUR);
images.set("SVK", SVK);
images.set("SWE", SWE);
images.set("SWZ", SWZ);
images.set("SYR", SYR);
images.set("TAN", TAN);
images.set("TGA", TGA);
images.set("THA", THA);
images.set("TJK", TJK);
images.set("TKM", TKM);
images.set("TLS", TLS);
images.set("TOG", TOG);
images.set("TPE", TPE);
images.set("TTO", TTO);
images.set("TUN", TUN);
images.set("TUR", TUR);
images.set("TUV", TUV);
images.set("TWN", TWN);
images.set("UAE", UAE);
images.set("UGA", UGA);
images.set("UKR", UKR);
images.set("URU", URU);
images.set("USA", USA);
images.set("UZB", UZB);
images.set("VAN", VAN);
images.set("VEN", VEN);
images.set("VIE", VIE);
images.set("VIN", VIN);
images.set("YEM", YEM);
images.set("ZAM", ZAM);
images.set("ZIM", ZIM);
images.set("CP1", CP1);
images.set("CP2", CP2);
images.set("CP3", CP3);
images.set("EOR", EOR);
images.set("OLY1", OLY1);
images.set("OLY2", OLY2);
images.set("NOFLAG", NOFLAG1);
images.set("gold", gold)
images.set("bronze", bronze)
images.set("silver", silver)
export default images;
